import { render, staticRenderFns } from "./DbSummaryCard.vue?vue&type=template&id=277ad015&"
import script from "./DbSummaryCard.vue?vue&type=script&lang=js&"
export * from "./DbSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports